<template>
  <div class="">
    <button @click="testCelery" >TECT</button>
  </div>
</template>

<script>
import ApiConnector from '@/backend/apiModels/taskApi'

export default {
  name:"TestCelery",
  setup(){
    const api = new ApiConnector()

    const testCelery = async() =>{
      api.get('tasks/test',{})
    }

    return {testCelery}
  },
 
};
</script>


<style scoped>

</style>
